var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.routerPath}})])
}
var staticRenderFns = []

export { render, staticRenderFns }